<div class="addContainer">
  <app-model-header [title]="title" (dialogClose)="dialogRef.close()"></app-model-header>
  <div mat-dialog-content>
    <!-- Available Plans -->
    <div class="available-plans">
      <!-- <h4>Available Plans</h4> -->
      @for (plan of planDatas; track plan) {
        <div class="plan-card" [class.selected]="plan === selectedPlan"
          (click)="selectPlan(plan)">
          <div class="plan-header">
            <h3 class="plan-name">{{ plan.name }}</h3>
            @if (plan.discount > 0) {
              <div class="discount">
                Save {{ plan.discount }}%
              </div>
            }
          </div>
          <p class="plan-description">{{ plan.description }}</p>
          <div class="plan-price">
            <span class="price-amount">${{ plan.price }}</span>
            @if (plan.payment_method === 'recurring') {
              <span>
                / {{ plan.duration }}
              </span>
            }
          </div>
          <ul class="plan-details-list">
            <li>{{ plan.number_of_user }} users included in this plan.</li>
            <li>Payment Method: {{ plan.payment_method | titlecase }}</li>
            <li>Duration: {{ plan.duration | titlecase }}</li>
          </ul>
        </div>
      }
    </div>

    <!-- Buttons -->
    <div class="row mt-2 mb-2 button-row">
      <button class="btn-space button-center" mat-raised-button color="primary" (click)="saveData()">
        {{ 'Proceed to Checkout' | translate }}
      </button>
      <button mat-raised-button color="warn" class="width-set-1 button-center" tabindex="-1"
        (click)="dialogRef.close()">
        {{ 'COMMON.ACTIONS.CANCEL' | translate }}
      </button>
    </div>
  </div>
</div>